//= require bijou/cjs_shim
//= require bijou/jquery.mask

require('../../../../../vendor/assets/javascripts/bijou/jquery.mask');

(function ($) {
  'use strict'

  var maskedFields = [
    { selector: '.us_telephone_number', mask: '(000) 000-0000' },
    { selector: '.zipcode', mask: '00000' },
    { selector: '.free_text_currency', mask: '#,##0', reverse: true }
  ]

  $(maskedFields).each(function () {
    $(this.selector).mask(this.mask, { reverse: this.reverse })
  })
})(window.jQuery)
